import React from "react";
import { useForm } from "react-hook-form";
import { useCreateEvaluationSection } from "./logic/useEvaluationSection";
import { message, Button } from "antd";
import "./EvaluationSectionForm.scss";

const EvaluationSectionForm = ({ formId, onSuccess, onCancel }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      title: "",
      order: "",
    }
  });

  const { mutate: createSection, isLoading } = useCreateEvaluationSection();

  const onSubmit = (data) => {
    if (!formId) {
      message.error("Missing formId. Please select or create a form.");
      return;
    }

    createSection(
      { ...data, formId, order: parseInt(data.order) },
      {
        onSuccess: () => {
          message.success("Section created successfully!");
          reset();
          if (onSuccess) onSuccess();
        },
        onError: (err) => {
          message.error(
            err.response?.data?.message || "Failed to create section"
          );
        },
      }
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="section-form-container">
      <div className="section-field">
        <label htmlFor="section-title">Section Title</label>
        <input
          id="section-title"
          type="text"
          placeholder="Enter section title "
          {...register("title", { required: "Section title is required" })}
          autoFocus
        />
        {errors.title && <p className="error">{errors.title.message}</p>}
      </div>

      <div className="section-field">
        <label htmlFor="section-order">Display Order</label>
        <input
          id="section-order"
          type="number"
          placeholder="Enter display order "
          {...register("order", {
            required: "Display order is required",
            min: { value: 1, message: "Order must be 1 or greater" },
          })}
        />
        {errors.order && <p className="error">{errors.order.message}</p>}
      </div>

      <div className="section-submit">
        {onCancel && (
          <Button 
            onClick={onCancel}
            style={{ 
              borderColor: '#d1d5db', 
              color: '#4b5563',
              fontWeight: '500'
            }}
          >
            Cancel
          </Button>
        )}
        <button type="submit" disabled={isLoading || isSubmitting}>
          {isLoading ? "Adding..." : "Add Section"}
        </button>
      </div>
    </form>
  );
};

export default EvaluationSectionForm;